var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C12 13.5523 11.5523 14 11 14H1C0.447715 14 0 13.5523 0 13C0 12.4477 0.447715 12 1 12H11C11.5523 12 12 12.4477 12 13ZM18 9C18 9.55229 17.5523 10 17 10H1C0.447716 10 0 9.55229 0 9C0 8.44771 0.447715 8 1 8H17C17.5523 8 18 8.44771 18 9ZM12 5C12 5.55228 11.5523 6 11 6H1C0.447715 6 0 5.55228 0 5C0 4.44772 0.447715 4 1 4H11C11.5523 4 12 4.44772 12 5ZM18 1C18 1.55228 17.5523 2 17 2H1C0.447716 2 0 1.55228 0 1C0 0.447715 0.447715 0 1 0H17C17.5523 0 18 0.447715 18 1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.ce3d543e4e955444fd8185455f92ebd1.svg";
export { ForwardRef as ReactComponent };